import React from "react"
import { useTranslation } from "react-i18next"

const UpdateBanner = ({ pill, children }) => {
  const { t } = useTranslation()

  return (
    <div className="update-banner shadow-xs mb-8">
      <div className="update-banner__pill p--sm">{pill ? pill: t("common.update")}</div>

      {children}
    </div>
  )
}

export default UpdateBanner
